module.exports = __webpack_public_path__ + "img/70.be8348e6.jpg";